var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "side" }, [
    _c("img", {
      staticClass: "banner",
      attrs: { src: require("@/assets/img/commerce-debut-guide/banner.webp") },
    }),
    _c("div", { staticClass: "menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _setup.selectedMenu === "menu1" },
          on: {
            click: function ($event) {
              return _setup.selectMenu("menu1")
            },
          },
        },
        [
          _vm._m(0),
          _c("div", { staticClass: "menu-content" }, [
            _c("span", { staticClass: "menu-text" }, [
              _vm._v(_vm._s(_vm.$t("commerceDebutGuideSideMenu.menu1.text"))),
            ]),
            _c("span", {
              staticClass: "menu-description",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("commerceDebutGuideSideMenu.menu1.description")
                ),
              },
            }),
          ]),
          _c("span", { staticClass: "menu-arrow" }, [_vm._v("＞")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _setup.selectedMenu === "menu2" },
          on: {
            click: function ($event) {
              return _setup.selectMenu("menu2")
            },
          },
        },
        [
          _vm._m(1),
          _c("div", { staticClass: "menu-content" }, [
            _c("span", { staticClass: "menu-text" }, [
              _vm._v(_vm._s(_vm.$t("commerceDebutGuideSideMenu.menu2.text"))),
            ]),
            _c("span", {
              staticClass: "menu-description",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("commerceDebutGuideSideMenu.menu2.description")
                ),
              },
            }),
          ]),
          _c("span", { staticClass: "menu-arrow" }, [_vm._v("＞")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _setup.selectedMenu === "menu3" },
          on: {
            click: function ($event) {
              return _setup.selectMenu("menu3")
            },
          },
        },
        [
          _vm._m(2),
          _c("div", { staticClass: "menu-content" }, [
            _c("span", { staticClass: "menu-text" }, [
              _vm._v(_vm._s(_vm.$t("commerceDebutGuideSideMenu.menu3.text"))),
            ]),
            _c("span", {
              staticClass: "menu-description",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("commerceDebutGuideSideMenu.menu3.description")
                ),
              },
            }),
          ]),
          _c("span", { staticClass: "menu-arrow" }, [_vm._v("＞")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _setup.selectedMenu === "menu4" },
          on: {
            click: function ($event) {
              return _setup.selectMenu("menu4")
            },
          },
        },
        [
          _vm._m(3),
          _c("div", { staticClass: "menu-content" }, [
            _c("span", { staticClass: "menu-text" }, [
              _vm._v(_vm._s(_vm.$t("commerceDebutGuideSideMenu.menu4.text"))),
            ]),
            _c("span", {
              staticClass: "menu-description",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("commerceDebutGuideSideMenu.menu4.description")
                ),
              },
            }),
          ]),
          _c("span", { staticClass: "menu-arrow" }, [_vm._v("＞")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "menu-icon-wrapper" }, [
      _c("img", {
        staticClass: "menu-icon",
        attrs: {
          src: require("@/assets/img/commerce-debut-guide/menu-icon-1.webp"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "menu-icon-wrapper menu-icon-wrapper-small" },
      [
        _c("img", {
          staticClass: "menu-icon",
          attrs: {
            src: require("@/assets/img/commerce-debut-guide/menu-icon-2.webp"),
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "menu-icon-wrapper menu-icon-wrapper-small" },
      [
        _c("img", {
          staticClass: "menu-icon",
          attrs: {
            src: require("@/assets/img/commerce-debut-guide/menu-icon-3.webp"),
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "menu-icon-wrapper" }, [
      _c("img", {
        staticClass: "menu-icon",
        attrs: {
          src: require("@/assets/img/commerce-debut-guide/menu-icon-4.webp"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }